import { render, staticRenderFns } from "./groupSkillLayout.vue?vue&type=template&id=12850055&scoped=true&"
import script from "./groupSkillLayout.vue?vue&type=script&lang=js&"
export * from "./groupSkillLayout.vue?vue&type=script&lang=js&"
import style0 from "./groupSkillLayout.vue?vue&type=style&index=0&id=12850055&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12850055",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12850055')) {
      api.createRecord('12850055', component.options)
    } else {
      api.reload('12850055', component.options)
    }
    module.hot.accept("./groupSkillLayout.vue?vue&type=template&id=12850055&scoped=true&", function () {
      api.rerender('12850055', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/robot/task/skill/groupSkillLayout.vue"
export default component.exports